import http from './http';
import {MENU_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = MENU_BASE;

// 전체 메뉴 목록 (관리자)
export const getMenus = withPerm(async () => {
  const response = await http.get(`${BASE_URL}`);
  return response.data;
}, 'GET', `${BASE_URL}`);

// 사용자 활성 메뉴 목록(useYn=Y 정렬)
export const getUserMenus = withPerm(async (force = false) => {
  const response = await http.get(`${BASE_URL}/user`, { params: { force } });
  return response.data;
}, 'GET', `${BASE_URL}/user`);

// 루트 메뉴 목록
export const getRootMenus = withPerm(async () => {
  const response = await http.get(`${BASE_URL}/root`);
  return response.data;
}, 'GET', `${BASE_URL}/root`);

// 특정 부모 하위 목록
export const getChildMenus = withPerm(async (parentMenuId) => {
  const response = await http.get(`${BASE_URL}/parent/${parentMenuId}`);
  return response.data;
}, 'GET', `${BASE_URL}/parent/{parentMenuId}`);

// 단건 조회
export const getMenu = withPerm(async (menuId) => {
  const response = await http.get(`${BASE_URL}/${menuId}`);
  return response.data;
}, 'GET', `${BASE_URL}/{menuId}`);

// 생성
export const createMenu = withPerm(async (payload) => {
  const response = await http.post(`${BASE_URL}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return response.data;
}, 'POST', `${BASE_URL}`);

// 일괄 생성
export const createMenuBatch = withPerm(async (payloadList) => {
  const response = await http.post(`${BASE_URL}/batch`, payloadList, { headers: { 'Content-Type': 'application/json' } });
  return response.data;
}, 'POST', `${BASE_URL}/batch`);

// 수정
export const updateMenu = withPerm(async (menuId, payload) => {
  const response = await http.put(`${BASE_URL}/${menuId}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return response.data;
}, 'PUT', `${BASE_URL}/{menuId}`);

// 삭제 (단건)
export const deleteMenu = withPerm(async (menuId) => {
  const response = await http.delete(`${BASE_URL}/${menuId}`);
  return response.data;
}, 'DELETE', `${BASE_URL}/{menuId}`);

// 일괄 삭제 (바디에 UUID 리스트)
export const deleteMenuBatch = withPerm(async (menuIds = []) => {
  const response = await http.delete(`${BASE_URL}`, { data: menuIds });
  return response.data;
}, 'DELETE', `${BASE_URL}`);

// 경로/라우트키 중복 검증
export const validateMenu = withPerm(async ({ path, rteKey, excludeMenuId }) => {
  const response = await http.post(`${BASE_URL}/validate`, { path, rteKey, excludeMenuId });
  return response.data;
}, 'POST', `${BASE_URL}/validate`);

// 컴포넌트 레지스트리
export const getMenuRegistry = withPerm(async () => {
  const response = await http.get(`${BASE_URL}/registry`);
  return response.data;
}, 'GET', `${BASE_URL}/registry`);

// 런타임 미등록 메뉴 목록
export const getRuntimeUnregisteredMenus = withPerm(async () => {
  const response = await http.get(`${BASE_URL}/runtime/unregistered`);
  return response.data;
}, 'GET', `${BASE_URL}/runtime/unregistered`);

// 유틸: 전체 목록으로 트리 구조 구성
export const buildMenuTree = (menus = []) => {
  const byParent = menus.reduce((acc, m) => {
    const key = m.parentMenuId || 'root';
    if (!acc[key]) acc[key] = [];
    acc[key].push(m);
    return acc;
  }, {});
  const makeNodes = (parentKey) => {
    return (byParent[parentKey] || [])
      .sort((a,b)=> (a.sortSeq ?? 0) - (b.sortSeq ?? 0))
      .map((m) => ({
        key: m.menuId,
        title: m.menuNm,
        data: m,
        children: makeNodes(m.menuId)
      }));
  };
  return makeNodes('root');
};

// 메뉴 재정렬
export const reorderMenus = withPerm(async (items = []) => {
  const response = await http.post(`${BASE_URL}/reorder`, items);
  return response.data;
}, 'POST', `${BASE_URL}/reorder`);
